<template>
  <div class="page" :class="[scrollContent ? 'scroll-content' : '']">    
    <PageLeft>
    <template v-slot:page>
        <div ref="content">        
            <div class="all-content">                
                <div class="image"><transition name="fade" mode="out-in" appear><img src="@/assets/images/las_vegas_market/bg_las-vegas-market_tourism.jpg" alt=""></transition></div>              
                  <div class="page-content content">
                    <transition name="slide-fade" mode="out-in" appear>
                      <TitleContent h2="Las Vegas Market" h1="Tourism" />
                    </transition>
                    <transition name="slide-fade" mode="out-in" appear>
                      <div class="text-content">                      
                        <p class='large yellow'>A Global Tourist Destination & Unique Additional Market Opportunity </p>
                        <p>Allegiant Stadium provides a unique additional market opportunity for the global touring industry. Las Vegas draws 42.5M annual visitors, 51% of which attend a show. The majority of Allegiant Stadium fans will travel from out of market, creating a previously untapped stadium destination market that will draw fans both nationally and globally.</p>
                        <Stats :stats="[
                          {label:'Annual<br/>Visitors', value:'42.5', suffix:'M'},
                          {label:'Attended a Show', value:'51', suffix:'%'},                          
                          {label:'Tickets Sold Per Week', value:'2', suffix:'M+'},
                          {label:'Available Hotel Rooms', value:'150,000', suffix:'+'},
                          {label:'Weekend Occupancy', value:'95', suffix:'%'},
                          {label:'Weekday Occupancy', value:'89', suffix:'%'},
                          ]" 
                        />
                        <p class="footnote">*According to LVCVA</p>
                      </div>                    
                    </transition>
                  </div>
            </div>
        </div>
    </template>
    </PageLeft>    
  </div>
</template>

<script>
import PageLeft from "@/patterns/PageLeft.vue";
import Stats from "@/components/Stats.vue";
import TitleContent from "@/patterns/TitleContent.vue";
export default {
  name: "TheStadium",
  components: { PageLeft, TitleContent, Stats },
  data: () => ({
    scrollContent: false,    
  }),  
  mounted() {
    window.addEventListener("resize", this.shouldScrollContent);
  },
  beforeDestroy: function () {
    window.removeEventListener("resize", this.shouldScrollContent);
  },
  methods: {
    shouldScrollContent() {
      this.scrollContent =
        this.$refs.content.clientHeight > window.innerHeight ? true : false;
    },
  },
};
</script>